// extracted by mini-css-extract-plugin
export default {"searchItemsList":"search-items-list_searchItemsList__vf04p","items":"search-items-list_items__rgzPu","hasmore":"search-items-list_hasmore__xnJrp"};